import React, {FC, MouseEvent, useState, useEffect, ChangeEvent}  from 'react';
import {useParams} from 'react-router';
import { useNavigate } from 'react-router-dom';

import md5 from 'md5';
// import MUI.
import NumberFormat from 'react-number-format';

import {Avatar, Button, Grid, Typography, Link, Box, Paper, TextField, 
  MenuItem, IconButton, Checkbox, FormControlLabel } from '@mui/material';
import {Menu as MenuIcon, AccountCircle as AccountCircleIcon, ModeEdit as ModeEditIcon,
  Home as HomeIcon, ManageAccounts as ManageAccountsIcon, Logout as LogoutIcon, Search as SearchIcon } from '@mui/icons-material';

import AddCircleIcon from '@mui/icons-material/AddCircle';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';

import InputAdornment from '@mui/material/InputAdornment';
import Loader, { ThreeDots } from "react-loader-spinner";


import DatePicker from '@mui/lab/DatePicker';
// import library.
import { useFieldArray, useForm, useFormContext, Controller, FormProvider, FieldArrayWithId, ArrayPath } from 'react-hook-form';
import {useQuery,useQueryClient, useMutation, useQueries, UseQueryResult } from "react-query";
import { useSnackbar } from 'notistack';
import { useTranslation  } from 'react-i18next';

// import user Component

// import user Library.
import useBankUserService from './service/BankUser';
import IBankUser, {defaultPasswordChange, IPasswordChange} from './model/BankUser';

import {useUserStore} from '../../library/store'; 

// const TextFieldRight = (props : any) => {
//   return(<TextField {...props} inputProps={{style: { textAlign: 'right' }}} /> );
// }
 

const BankUserChangePwdForm: FC<IPasswordChange> = (props: IPasswordChange = defaultPasswordChange) => {

  const { setCurrentEntity,currentUser, setIsBackendOperation, shouldResetPassword,
    setCurrentObjectDataDef, setCurrentObjectKey } = useUserStore();
  const {language: lg} = currentUser;
  const navigate = useNavigate();

  const { t, i18n } = useTranslation();

  const {policyID} = useParams();

  const { enqueueSnackbar } = useSnackbar();

  const {updatePassword} = useBankUserService();

  const [_policyID, _setPolicyID] = useState<number>( Number( policyID || 0 ) );

  const methods = useForm<IPasswordChange>( {
    defaultValues:{...defaultPasswordChange, login: currentUser.login }
  } );

  const { register, setValue ,getValues ,watch, reset ,control , formState: { errors } } = methods;
    
 
  
  const queryClient = useQueryClient();
  const {isLoading, isError, isSuccess ,error,mutate } = useMutation<IPasswordChange,Error,IPasswordChange>(updatePassword, 
    {        
      onSuccess: (data: IPasswordChange) => {
        enqueueSnackbar( t('_Operation_done'), { variant: 'success',
              anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 1000 }); 
          
        // reset(data);
        // queryClient.invalidateQueries(['BankPolicy',data.policyID]);
      },
      onError: (err: Error) => {        
        enqueueSnackbar( error?.message, { variant: 'error',
              anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 });
      }
    });
  
 
  useEffect( () => {
    setCurrentEntity(t('ChangePassword'));
    //setCurrentObjectDataDef('00115'); //
    //setCurrentObjectKey( _policyID.toString());
    if(shouldResetPassword)
      enqueueSnackbar( t('You should change password before continue'), { variant: 'info',
        anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 1000 }); 
    
  }, [] );

  useEffect( () => {
    setIsBackendOperation(isLoading);
  }, [isLoading])

  // useEffect( () => { 
    // const data = getValues();
    // const tmpPolicyID = data.policyID || 0;
    // if(_policyID !== tmpPolicyID) {    //console.log('useEffect ...'); console.log(_data);  
      
    //   reset(_data);
      //setIsDataLoading(false);
    //}
  // }, [_data, reset]);

  

  

  const saveData = async (event: MouseEvent<HTMLButtonElement>) => {
    const data = getValues();   
    if(data.newPassword !== data.newPasswordConfirm) {
        enqueueSnackbar( t('Password and confirmation are not the same'), { variant: 'error',
          anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 });
        return;
    }
      
    mutate({...data,password: md5(data.password), newPassword: md5(data.newPassword)});    
  }

  const listData = async (event: MouseEvent<HTMLButtonElement>) => {
    
  }

    return (
      <>
        <FormProvider {...methods} >
          <Grid container component="main"  sx={{  width: '100%' }} alignItems="flex-start">
                    
            <Grid item xs={12} sm={6} md={4} component={Paper} elevation={0} square>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }} >
                <Box sx={{ mt: 1, width: '100%' }} >                                       
                  <TextField  sx={{width:'calc(100% - 8px)'}} id="login" label={t('Login')} {...register('login')} disabled
                    inputProps={ { autoComplete: 'new-password', style: {textTransform: 'none'} } }  />   
                    <Button id='btnSave' onClick={saveData} sx={ {display:'none'}}  />  
                </Box>
                <Box sx={{ mt: 1, width: '100%' }} >                                       
                  <TextField  sx={{width:'calc(100% - 8px)'}} type="password"  id="password" label={t('Current Password')} {...register('password')}
                    inputProps={ { autoComplete: 'new-password', style: {textTransform: 'none'} } }  />     
                </Box>
                <Box sx={{ mt: 1, width: '100%' }} >                                       
                  <TextField  sx={{width:'calc(100% - 8px)'}} type="password"  id="newPassword" label={t('New Password')} {...register('newPassword')}
                    inputProps={ { autoComplete: 'new-password', style: {textTransform: 'none'} } }  />     
                </Box>
                <Box sx={{ mt: 1, width: '100%' }} >                                       
                  <TextField  sx={{width:'calc(100% - 8px)'}} type="password" id="newPasswordConfirm" label={t('Confirm Password')} {...register('newPasswordConfirm')}
                    inputProps={ { autoComplete: 'new-password', style: {textTransform: 'none'} } }   />     
                </Box>
                <Box sx={{ mt: 1, width: '100%' }} >                                       
                { shouldResetPassword && <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }} onClick={saveData} id="btnPostLogin">
                  {isLoading ? <ThreeDots 
                          color='#00BFFF'
                          height={'100%'}
                          //width={100}
                          //timeout={3000} //3 secs
                        /> : t('Update password')}
                </Button> }    
                </Box>
              </Box>
            </Grid>
             
            
                        
          </Grid>          
        </FormProvider>
      </>
    );
  }
  
  export default BankUserChangePwdForm;